import React, { useContext } from 'react';
import { Web3Context } from '../../context/Web3Context';
import './Notification.css';

const Notification = () => {
  const { notification } = useContext(Web3Context);

  if (!notification) return null;

  return (
    <div className={`notification notification-${notification.type}`} key={notification.id}>
      <div className="notification-icon">
        {notification.type === 'success' && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" />
            <path d="M6 10l3 3 5-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
        {notification.type === 'error' && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" />
            <path d="M7 7l6 6M13 7l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        )}
        {notification.type === 'warning' && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 2L1 18h18L10 2z" stroke="currentColor" strokeWidth="2" fill="none" strokeLinejoin="round" />
            <path d="M10 8v4M10 14v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        )}
        {notification.type === 'info' && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="2" />
            <path d="M10 6v1M10 9v5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        )}
      </div>
      <span className="notification-message">{notification.message}</span>
    </div>
  );
};

export default Notification;
